module.exports = __webpack_public_path__ + "static/media/bg.87c785ca.png";